/**
 * The Settings tab's Figma icons (toolbar 6828:45251 and the label info icon), inline so they
 * take the text colour: stroke is `currentColor`, and the caller's token sets it. As image files
 * their baked hex strokes stayed light-mode grey on the dark theme.
 */

interface IconProps {
	className?: string;
}

const STROKE = {
	stroke: 'currentColor',
	strokeLinecap: 'round',
	strokeLinejoin: 'round'
} as const;

export const BoldIcon = ({ className }: IconProps) => (
	<svg width='14' height='14' viewBox='0 0 14 14' fill='none' aria-hidden='true' className={className}>
		<path
			d='M3.5 7H8.75C9.36884 7 9.96233 7.24583 10.3999 7.68342C10.8375 8.121 11.0833 8.71449 11.0833 9.33333C11.0833 9.95217 10.8375 10.5457 10.3999 10.9832C9.96233 11.4208 9.36884 11.6667 8.75 11.6667H4.08333C3.92862 11.6667 3.78025 11.6052 3.67085 11.4958C3.56146 11.3864 3.5 11.238 3.5 11.0833V2.91667C3.5 2.76196 3.56146 2.61358 3.67085 2.50419C3.78025 2.39479 3.92862 2.33333 4.08333 2.33333H8.16667C8.78551 2.33333 9.379 2.57917 9.81658 3.01675C10.2542 3.45434 10.5 4.04783 10.5 4.66667C10.5 5.2855 10.2542 5.879 9.81658 6.31658C9.379 6.75417 8.78551 7 8.16667 7'
			strokeWidth={1.16667}
			{...STROKE}
		/>
	</svg>
);

export const ItalicIcon = ({ className }: IconProps) => (
	<svg width='14' height='14' viewBox='0 0 14 14' fill='none' aria-hidden='true' className={className}>
		<path d='M11.083 2.33331H5.83301' strokeWidth={1.16667} {...STROKE} />
		<path d='M8.16699 11.6667H2.91699' strokeWidth={1.16667} {...STROKE} />
		<path d='M8.75 2.33333L5.25 11.6667' strokeWidth={1.16667} {...STROKE} />
	</svg>
);

export const LinkIcon = ({ className }: IconProps) => (
	<svg width='14' height='14' viewBox='0 0 14 14' fill='none' aria-hidden='true' className={className}>
		<path
			d='M5.25033 9.91665H4.08366C3.31011 9.91665 2.56825 9.60936 2.02126 9.06237C1.47428 8.51539 1.16699 7.77353 1.16699 6.99998C1.16699 6.22643 1.47428 5.48457 2.02126 4.93758C2.56825 4.3906 3.31011 4.08331 4.08366 4.08331H5.25033'
			strokeWidth={1.16667}
			{...STROKE}
		/>
		<path
			d='M8.75 4.08333H9.91667C10.6902 4.08333 11.4321 4.39062 11.9791 4.93761C12.526 5.48459 12.8333 6.22645 12.8333 7C12.8333 7.77355 12.526 8.51541 11.9791 9.0624C11.4321 9.60938 10.6902 9.91667 9.91667 9.91667H8.75'
			strokeWidth={1.16667}
			{...STROKE}
		/>
		<path d='M4.66699 7H9.33366' strokeWidth={1.16667} {...STROKE} />
	</svg>
);

/** The thin rule between the text styles and the link button. */
export const ToolbarDivider = ({ className }: IconProps) => (
	<svg width='1' height='12' viewBox='0 0 1 12' fill='none' aria-hidden='true' className={className}>
		<path d='M0.5 0.5V11.5' {...STROKE} />
	</svg>
);

export const InfoIcon = ({ className }: IconProps) => (
	<svg width='12' height='12' viewBox='0 0 12 12' fill='none' aria-hidden='true' className={className}>
		<path
			d='M6 8V6M6 4H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z'
			strokeWidth={1.2}
			{...STROKE}
		/>
	</svg>
);
